import React from "react";

import { login as doLogin, logout as doLogout } from "@/api/auth";
import { updateUserInformation } from "@/tracking";
import { isLoggedIn as authIsLoggedIn } from "@/utils/auth";

interface AuthContextValue {
  isLoggedIn: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = React.createContext<AuthContextValue | null>(null);

export function AuthProvider(props: { children: React.ReactNode }) {
  const [isLoggedIn, setIsLoggedIn] = React.useState(authIsLoggedIn);

  const logout = () => doLogout().then(() => setIsLoggedIn(false));

  const login = (username: string, password: string) =>
    doLogin(username, password).then(() => setIsLoggedIn(true));

  React.useEffect(() => {
    updateUserInformation();
  }, [isLoggedIn]);

  return (
    <AuthContext.Provider value={{ isLoggedIn, logout, login }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = React.useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
